module.exports = __webpack_public_path__ + "img/物料信息.6da4411f.svg";